import { z } from "zod";

export const productLabResultSchema = z.object({
  certificate_url: z.string(),
  id: z.number(),
  name: z.string(),
});
